import { frontendURL } from '../../../helper/URLHelper';
import account from './account/account.routes';
import accountStatuses from './accountStatuses/accountStatus.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import templates from './templates/templates.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import captain from './captain/captain.routes';
import data from './data/data.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [
          'settings.account_manage',
          'settings.availability_statuses_manage',
          'settings.assignment_policies_manage',
          'settings.bots_manage',
          'settings.custom_attributes_manage',
          'settings.automation_manage',
          'settings.billing_manage',
          'canned_responses.manage',
          'inboxes.manage',
          'settings.integrations_manage',
          'labels.manage',
          'macros.manage',
          'teams.view',
          'settings.security_manage',
          'settings.conversation_workflow_manage',
          'captain.manage',
        ],
      },
      redirect: to => {
        const permissions = getUserPermissions(
          store.getters.getCurrentUser,
          to.params.accountId
        );
        const destinations = [
          ['settings.account_manage', 'general_settings_index'],
          ['inboxes.manage', 'settings_inbox_list'],
          ['teams.view', 'settings_teams_list'],
          ['labels.manage', 'labels_list'],
          ['settings.automation_manage', 'automation_list'],
          ['canned_responses.manage', 'canned_list'],
          ['macros.manage', 'macros_wrapper'],
        ];
        const destination = destinations.find(([permission]) =>
          permissions.includes(permission)
        );

        return { name: destination?.[1] || 'home', params: to.params };
      },
    },
    ...account.routes,
    ...accountStatuses.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...templates.routes,
    ...integrations.routes,
    ...data.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...conversationWorkflow.routes,
    ...captain.routes,
  ],
};
